export const webScrapingTranslations = {
  en: {
    hero: {
      badge: 'Standalone Course',
      title: 'Web Scraping',
      subtitle: 'Extract valuable data from any website with AI-powered automation',
      note: 'This is a separate course, not included in the Full Program'
    },
    cta: {
      goToDashboard: 'Go to Dashboard',
      backToHome: 'Back to Home'
    },
    content: {
      badge: '🔍 Data Extraction',
      description: 'Learn to build powerful web scrapers that collect, process, and analyze data from any website. Master the art of ethical data extraction with AI assistance.'
    },
    features: {
      title: 'What You Will Learn',
      items: [
        {
          title: 'Data Extraction Basics',
          description: 'Learn HTML structure, CSS selectors, and XPath to target any element on a webpage.'
        },
        {
          title: 'API Integration',
          description: 'Connect scraped data to databases, spreadsheets, and external services automatically.'
        },
        {
          title: 'Anti-Bot Bypass',
          description: 'Ethical techniques to handle CAPTCHAs, rate limiting, and dynamic content.'
        },
        {
          title: 'Data Processing',
          description: 'Clean, transform, and structure raw data into actionable insights.'
        },
        {
          title: 'Automation Pipelines',
          description: 'Build scheduled scrapers that run automatically and notify you of changes.'
        },
        {
          title: 'Real-World Projects',
          description: 'Price monitoring, lead generation, market research, and competitive analysis.'
        }
      ]
    }
  },
  uk: {
    hero: {
      badge: 'Окремий курс',
      title: 'Веб-скрапінг',
      subtitle: 'Витягуйте цінні дані з будь-якого сайту за допомогою ШІ-автоматизації',
      note: 'Це окремий курс, не входить до Full Program'
    },
    cta: {
      goToDashboard: 'Перейти до панелі',
      backToHome: 'На головну'
    },
    content: {
      badge: '🔍 Витягування даних',
      description: 'Навчіться створювати потужні веб-скрапери, які збирають, обробляють та аналізують дані з будь-якого сайту. Опануйте мистецтво етичного збору даних з допомогою ШІ.'
    },
    features: {
      title: 'Що ви вивчите',
      items: [
        {
          title: 'Основи витягування даних',
          description: 'Вивчіть HTML-структуру, CSS-селектори та XPath для націлювання на будь-який елемент веб-сторінки.'
        },
        {
          title: 'Інтеграція з API',
          description: 'Автоматично підключайте зібрані дані до баз даних, таблиць та зовнішніх сервісів.'
        },
        {
          title: 'Обхід захисту від ботів',
          description: 'Етичні техніки для роботи з CAPTCHA, обмеженнями швидкості та динамічним контентом.'
        },
        {
          title: 'Обробка даних',
          description: 'Очищуйте, трансформуйте та структуруйте сирі дані в корисні інсайти.'
        },
        {
          title: 'Автоматизовані конвеєри',
          description: 'Створюйте скрапери за розкладом, які працюють автоматично та повідомляють про зміни.'
        },
        {
          title: 'Реальні проекти',
          description: 'Моніторинг цін, генерація лідів, дослідження ринку та конкурентний аналіз.'
        }
      ]
    }
  }
};
